// src/components/Common/NoDataMessage.tsx
import React from 'react';
import './noDataMessage.css'; // Create a CSS file for styling

const NoDataMessage: React.FunctionComponent = () => {
    return (
        <div className="no-data-message">
            <p>No data available</p>
        </div>
    );
};

export default NoDataMessage;
